
module.exports = class ToolchestAreaChairButton extends React.Component
  displayName: 'ToolchestAreaChairButton'

  constructor: (props) ->
      super(props)
      # Expects: @props.
      # my_accepted_roles
      @state = { }

  render: =>

      if @props.tool_selected is 'areachair_tools'
          card_className = 'card light_green'
      else
          card_className = 'card light_gray'

      <div className={card_className}>
        <div className="card-body">
            <h2 className="card-title">
                <button className='btn btn-primary'
                        onClick={ @props.onClick.bind(this, {tools: 'areachair_tools', show_this: 'areachair_tools'}) }>
                    area chair tools
                </button>
            </h2>
            <p className="card-text">
                Use the area chair tools.
            </p>
        </div>
      </div>
